import React from 'react';
import Link from '@loomstateorg/shared-frontend/components/commercetools-ui/atoms/link';
import { useFormat } from '@loomstateorg/shared-frontend/hooks/useFormat';
import Button from 'components/commercetools-ui/Button';
import Image404 from 'public/images/shy-lens.png';
import Image from 'frontastic/lib/image';

const NotFound = () => {
  const { formatMessage } = useFormat({ name: 'common' });
  const { formatMessage: formatCheckoutMessage } = useFormat({ name: 'checkout' });

  return (
    <div className="relative h-[80vh] lg:h-[60vh]" data-testid="not-found">
      <div className="absolute left-1/2 top-1/2 flex w-full -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center gap-0 pb-60 lg:flex-row-reverse lg:gap-50">
        <div className="relative size-300 lg:size-350">
          <Image src={Image404} alt={formatMessage({ id: 'page.notFound', defaultMessage: 'Page not found' })} />
        </div>
        <div className="mt-5 text-center lg:text-left">
          <h1 className="text-32" data-testid="not-found-title">
            {formatMessage({ id: 'page.notFound', defaultMessage: 'Page not found' })}
          </h1>
          <p className="mt-24">
            {formatMessage({
              id: 'page.notFound.desc',
              defaultMessage:
                "The page you were looking for couldn't be found. It may have been deleted, renamed, or doesn't exist.",
            })}
          </p>
          <Link link="/" data-testid="home">
            {/* testid-ignore: visual button inside the home link; the link is the navigation target */}
            <Button variant="primary" className="mt-28 px-48 py-12 text-16 font-medium">
              {formatCheckoutMessage({ id: 'page.notFound.cta', defaultMessage: 'Go back home' })}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
